<div class="modal-container">
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button (click)="dismiss()" color="light">
                    <ion-icon slot="icon-only" class="icon haleo-close"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>
                {{'thoughtRecord.assessment.addCognitiveDistortion' | translate}}
            </ion-title>
        </ion-toolbar>
    </ion-header>
    <div class="content">
        <ion-list lines="none">
            <ion-item *ngFor="let option of options" (click)="selectOption(option)">
                <ion-label class="block-title">
                    <div>{{option.label}}</div>
                    <ion-button class="link-small" fill="clear" color="primary" size="extra-small"
                                [routerLink]="['/thought-record/challenge-negative-thought', option.value]">
                        {{'thoughtRecord.assessment.challengeNegativeThoughtsDetail' | translate}}
                    </ion-button>
                </ion-label>
                <img slot="end" [src]="'assets/img/thought-record/cognitive-distortions/'+option.value+'.png'"/>
            </ion-item>
        </ion-list>
    </div>
</div>
